<template>
    <div>
        <div class="hero int-page">
            <TDSHead/>
        </div>
        <div class="container-fluid bg-light main-content">
            <div class="container py-4 py-lg-8">
                <div class="row">
                    <div class="col-12 mb-3 text-center mb-6">
                        <h1 class="font-weight-bold text-primary">{{$t('servizi.title')}}</h1>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div class="card-deck card-services">
                            <Card :title="$t('servizi.timing.title')"
                                  image_bg="servizi/bg/timing.png"
                                  image_icon="servizi/icons/timing.svg"
                                  :text="$t('servizi.timing.text')"
                                  :detail_text="$t('servizi.btn_detail_text')"
                                  :cta_text="$t('servizi.btn_cta_text')"
                                  :url_video="'https://player.vimeo.com/external/361008358.hd.mp4?s=eeb92b808ddf084296dcf47e1191bddbcdea9990&profile_id=175'">
                            </Card>
                            <Card :title="$t('servizi.iscrizioni.title')"
                                  image_bg="servizi/bg/gestione-iscrizioni.png"
                                  image_icon="servizi/icons/gestione-iscrizioni.svg"
                                  :text="$t('servizi.iscrizioni.text')"
                                  :detail_text="$t('servizi.btn_detail_text')"
                                  :cta_text="$t('servizi.btn_cta_text')"
                                  :url_video="'https://player.vimeo.com/external/361008460.hd.mp4?s=53e2b9c6b3f69ee61b947ae998c64c969cd5bb93&profile_id=175'">
                            </Card>
                            <Card :title="$t('servizi.materiale_gara.title')"
                                  image_bg="servizi/bg/materiali-gara.png"
                                  image_icon="servizi/icons/materiali-gara.svg"
                                  :text="$t('servizi.materiale_gara.text')"
                                  :detail_text="$t('servizi.btn_detail_text')"
                                  :cta_text="$t('servizi.btn_cta_text')"
                                  :url_video="'https://player.vimeo.com/external/361008552.hd.mp4?s=036141db7b636fa819ff50d039bc48d8e98cb42f&profile_id=175'">
                            </Card>
                        </div>
                        <div class="card-deck card-services mt-5">
                            <Card :title="$t('servizi.grafica_tv.title')"
                                  image_bg="servizi/bg/grafica-tv.png"
                                  image_icon="servizi/icons/grafica-tv.svg"
                                  :text="$t('servizi.grafica_tv.text')"
                                  :detail_text="$t('servizi.btn_detail_text')"
                                  :cta_text="$t('servizi.btn_cta_text')"
                                  :url_video="'https://player.vimeo.com/external/361008639.hd.mp4?s=7377da8828a42ebaecdde791d157c162d30ac559&profile_id=175'">
                            </Card>
                            <Card :title="$t('servizi.materiale_info.title')"
                                  image_bg="servizi/bg/materiali-info.png"
                                  image_icon="servizi/icons/materiali-info.svg"
                                  :text="$t('servizi.materiale_info.text')"
                                  :detail_text="$t('servizi.btn_detail_text')"
                                  :cta_text="$t('servizi.btn_cta_text')"
                                  :url_video="'https://player.vimeo.com/external/361008717.hd.mp4?s=8a32bc7da8bd7aaa1b9e5c2db5c519380cc4826a&profile_id=175'">
                            </Card>
                            <div class="card text-center">
                                <div class="d-flex align-items-center h-100 py-8 py-md-0">
                                    <div>
                                        <div>
                                            <span class="font-weight-bold text-primary h4">{{$t('servizi.servizi_custom_title')}}</span>
                                        </div>
                                        <div class="card-body text-center">
                                            <div class="card-text">{{$t('servizi.servizi_custom_text')}}</div>
                                            <div class="d-flex align-items-center justify-content-center mt-3">
                                                <RichiestaContatto  :button="$t('servizi.servizi_custom_cta_text')"></RichiestaContatto>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TDSFoot/>
    </div>
</template>

<script>
    import BaseVue from "../views/BaseVue"
    import Card from '../components/Card'
    import RichiestaContatto from '../components/RichiestaContatto'

    export default {
        extends: BaseVue,
        components: {
            Card,
            RichiestaContatto
        },
        name: 'servizi',
        metaInfo() {
            return {
                title: 'Servizi - TDS.sport',
            }
        }
    }
</script>

